import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Vue from 'vue'
import Weather from './weather/src/weather.vue'
import Help from './help/src/help.vue'
import Forum from './forum/Forum.vue'

import VueResource from 'vue-resource'
import {VueMasonryPlugin} from 'vue-masonry';

Vue.use(VueResource);
Vue.use(VueMasonryPlugin);

Sentry.init({
    dsn: 'https://667a08271258427d91bddde15c38f7ea@sentry-test.app.unistra.fr/7',
    release: process.env.VERSION,
    environment: process.env.VUE_APP_DEPLOYMENT_ENV,
    integrations: [
        new Integrations.Vue({
            Vue,
            attachProps: true,
        }),
    ],
});



new Vue({
        el: "#weather",
        render: w => w(Weather),
    })

new Vue({
        el: "#help",
        render: h => h(Help),
    })

new Vue({
        el: "#forum",
        render: f => f(Forum),
    })



// WEBPACK FOOTER //
// ./src/main.js